<template>
  <div
    data-testid="accommodation-card"
    class="tw:mb-2 tw:border tw:border-gray-300 tw:rounded-xl tw:p-3 tw:flex tw:flex-col tw:sm:flex-row tw:gap-5"
  >
    <div class="tw:w-full tw:sm:w-[100px] tw:sm:self-stretch tw:flex-shrink-0 tw:overflow-hidden tw:rounded-lg">
      <img class="tw:w-full tw:h-full tw:object-cover" :src="mainImage" :alt="currentAccommodation.name" />
    </div>
    <div>
      <h4 data-testid="accommodation-name" class="tw:text-base tw:font-bold tw:mb-[2px]">
        {{ currentAccommodation.name }}
      </h4>
      <p class="tw:text-sm tw:mb-3">{{ $t('subscription_badge_header') }}</p>
      <div data-testid="promo-badge" class="tw:flex tw:flex-col tw:sm:flex-row tw:gap-2">
        <div
          class="tw:border tw:border-gray-800 tw:rounded-full tw:flex tw:items-center tw:py-[6px] tw:px-2 tw:gap-x-[6px]"
        >
          <img :src="GiftImg" alt="Promo" class="tw:h-4 tw:w-4" />
          <p class="tw:font-bold tw:text-xs">
            {{ 'Promo: '
            }}<span :class="hasActiveOffer ? 'tw:text-green-700' : 'tw:text-gray-400'">{{
              hasActiveOffer ? $t('contact_badge_live') : $t('app_description_status_not_live')
            }}</span>
          </p>
        </div>
        <div
          class="tw:border tw:border-gray-800 tw:rounded-full tw:flex tw:items-center tw:py-1 tw:px-2 tw:gap-x-[6px]"
        >
          <img :src="PhoneImg" :alt="$t('contact_info_badge')" class="tw:h-4 tw:w-4" />
          <p class="tw:font-bold tw:text-xs">
            {{ $t('contact_info_badge') }}{{ ' ' }}<span class="tw:text-green-700">{{ $t('contact_badge_live') }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'

const GiftImg = new URL('/src/assets/img/studio-plus/GiftIcon.svg', import.meta.url)
const PhoneImg = new URL('/src/assets/img/studio-plus/PhoneIcon.svg', import.meta.url)

const props = defineProps({
  currentAccommodation: {
    type: Object,
    required: true,
    validator: value => value?.name && value?.mainImageUrls,
  },
  hasActiveOffer: {
    type: Boolean,
    default: false,
  },
})

const mainImage = computed(() => {
  if (props.currentAccommodation?.mainImageUrls?.imagePath) {
    return `https://imgcy.trivago.com/c_fill,d_dummy.jpeg,e_sharpen:60,f_auto,h_208,q_auto,w_231/${props.currentAccommodation?.mainImageUrls?.imagePath}`
  } else {
    return `https://imgcy.trivago.com/c_fill,d_dummy.jpeg,e_sharpen:60,f_auto,h_208,q_auto,w_231/dummy.jpeg`
  }
})
</script>
